import React from 'react';

import {FormInput} from 'src/components/input';
import {CustomValidatedControl} from 'src/contexts/validation-context';
import {useFormatInputValue} from 'src/hooks/useFormatInputValue';
import {CONFERENCE_NAME_CONTROL} from 'src/modules/create-conference/constants';

type Props = {
    conferenceName: string,
    onChange: (accountName: string) => void,
    readonly?: boolean,
};

export const ConferenceNameInput = (props: Props) => {
    const {onChange, readonly} = props;

    useFormatInputValue({
        value: props.conferenceName,
        setValue: onChange,
        regex: /[^0-9 A-Za-z$&+,:{};_=?@#|'\]<>.^*()%!-\\/]/g,
    });

    return (
        <CustomValidatedControl name={CONFERENCE_NAME_CONTROL}>
            {error => (
                <FormInput
                    maxLength={255}
                    readOnly={readonly}
                    placeholder="Conference name"
                    value={props.conferenceName}
                    valid={error ? false : undefined}
                    errorDescription={error}
                    onBlur={onChange}
                />
            )}
        </CustomValidatedControl>
    );
};
